import MoreVert from '@mui/icons-material/MoreVert';
import { Dropdown, IconButton, Menu, MenuButton, MenuList, styled } from "@mui/joy";
import Box from "@mui/joy/Box";
import Grid from "@mui/joy/Grid";
import Stack from "@mui/joy/Stack";
import Typography from "@mui/joy/Typography";
import { ClickAwayListener, Popper } from '@mui/material';
import { gradientTint } from "@utils/gradientTint";
import { useRef, useState } from "react";

const Popup = styled(Popper)({
    zIndex: 1000,
  });

export function SubheaderTitle({title, subtitle = null, tint = 'black'}) {
    return (
        <Typography fontWeight={'bold'} textColor={`${tint}.900`} sx={{textAlign: {xs: 'center', sm: 'left'}}}>
            {title}
            {subtitle && (<>
                {/* {' '} */}
                <Typography sx={{marginLeft: 2}} fontWeight={'normal'} fontSize={'sm'} textColor={`${tint}.950`}>{subtitle}</Typography>
            </>)}
        </Typography>
    );
}

export default function Subheader({
    managed = true,
    title = '',
    subtitle = null,
    rightActions = <></>,
    children = <></>,
    tint = null,//'neutral',
}) {
    const buttonRef = useRef/*<HTMLButtonElement>*/(null);
    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpen(false);
    };

    const handleListKeyDown = (event/*: React.KeyboardEvent<HTMLElement>*/) => {
        if (event.key === 'Tab') {
            setOpen(false);
        } else if (event.key === 'Escape') {
            buttonRef?.current?.focus();
            setOpen(false);
        }
    };

    return (
    <Stack
        sx={theme => ({
            position: 'sticky',
            zIndex: 20,
            top: 'var(--Header-height)',
            backgroundColor: tint ? theme.palette[tint][300] : theme.palette.background.level1,

            backgroundImage: tint && `linear-gradient(180deg, ${theme.palette[tint][400]} 0%, ${theme.palette[tint][300]} 0.25rem);`,

            // backgroundImage: tint ? `linear-gradient(180deg, ${theme.palette[tint][100]} 0%, ${theme.palette[tint][50]} 20%, ${theme.palette.neutral[100]} 100%);` : null,
            // backgroundImage: tint && `linear-gradient(180deg, ${theme.palette[tint][100]} 0%, ${theme.palette[tint][50]} 40%);`,// : null,
            paddingX: 2,
            // paddingY: 1,
            borderBottom: '1px solid',
            borderColor: tint ? theme.palette[tint][300] : 'divider',
            // boxShadow: 'md',

            [theme.getColorSchemeSelector('dark')]: {
                // backgroundImage: tint && `linear-gradient(180deg, ${theme.palette[tint][50]} 0%, transparent 100%);`,// : null,
                backgroundImage: tint && `linear-gradient(180deg, ${theme.palette[tint][50]}6B 0%, ${theme.palette[tint][100]}6B 100%);`,// : null,
                //
            },
        })}
    >
    {managed === true && (
        <Grid container columns={12} sx={{gap: {xs: 0.5, sm: 2}, flexGrow: 1, alignItems: 'center'}}>
            <Grid xs sx={{paddingY: 1}}>
                <SubheaderTitle title={title} subtitle={subtitle} tint={tint} />
            </Grid>
            <Grid /*xs={'auto'}*/ xs={12} sm="auto" sx={{
                /*
                display: {
                    xs: 'none',
                    sm: 'initial',
                },
                */
                paddingBottom: {xs: 1, sm: 0}
            }} /*sx={theme => ({
                flex: '0 1 100%',
                // flexBasis: '100%',
                [theme.breakpoints.up('md')]: {
                    flexBasis: '25%',
                    // flex: '0 1 100%',
                }
                // xs: {flexBasis: '100%'}, md: {flexBasis: '75%'}
            })}*/>
            {/* {rightActions} */}
                <Box
                    sx={{
                      display: 'flex',
                    /*
                    display: {
                        xs: 'none',
                        sm: 'flex',
                    },
                    */
                    alignItems: 'center',
                    gap: 1.5,
                    justifyContent: {xs: 'space-between', sm: 'flex-end'},
                    }}
                >
                    {children}
                </Box>
                {/*
                <Box
                    sx={{
                    display: {
                        xs: 'flex',
                        sm: 'none',
                    },
                    alignItems: 'center',
                    gap: 2,
                    justifyContent: {xs: 'space-between', sm: 'flex-end'},
                    }}
                >
                    <IconButton
                        ref={buttonRef}
                        id="composition-button"
                        aria-controls={'composition-menu'}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        variant="outlined"
                        color="neutral"
                        onClick={() => {
                        setOpen(!open);
                        }}
                    >
                        <MoreVert/>
                    </IconButton>
                    <Popup
                        role={undefined}
                        id="composition-menu"
                        open={open}
                        anchorEl={buttonRef.current}
                        disablePortal
                        modifiers={[
                        {
                            name: 'offset',
                            options: {
                            offset: [0, 4],
                            },
                        },
                        ]}
                    >
                        <ClickAwayListener
                        onClickAway={(event) => {
                            if (event.target !== buttonRef.current) {
                            handleClose();
                            }
                        }}
                        >
                        <MenuList
                            variant="outlined"
                            onKeyDown={handleListKeyDown}
                            sx={{ boxShadow: 'md', p: 1, gap: 2 }}
                        >
                            {children}
                        </MenuList>
                        </ClickAwayListener>
                    </Popup>
                </Box>
                */}
            </Grid>
        </Grid>

    )}
    {managed !== true && (
        {children}
    )}
    </Stack>
    )
}
